
import { useLanguage } from "@/contexts/LanguageContext";
import { useEffect, useState } from "react";

interface PaymentAmountProps {
  amount: number;
}

const PaymentAmount = ({ amount }: PaymentAmountProps) => {
  const { t, language } = useLanguage();
  const [displayAmount, setDisplayAmount] = useState(amount);

  // Ensure we have a valid amount, even if it's passed as 0
  useEffect(() => {
    if (amount <= 0) {
      // Try to get amount from localStorage if the passed amount is 0
      const budgetCalculations = localStorage.getItem('budgetCalculations');
      if (budgetCalculations) {
        const { totalBudget } = JSON.parse(budgetCalculations);
        setDisplayAmount(parseFloat(totalBudget) || amount);
      }
    } else {
      setDisplayAmount(amount);
    }
  }, [amount]);

  const formatNumber = (num: number) => {
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <div className="rounded-lg bg-muted p-4">
      <div className={`flex justify-between items-center ${language === 'ar' ? 'flex-row-reverse' : ''}`}>
        <span className="text-sm font-bold">
          {language === 'ar' ? `: ${t('totalAmount')}` : `${t('totalAmount')}:`}
        </span>
        <span className="text-lg font-bold text-primary">{formatNumber(displayAmount)} SAR</span>
      </div>
    </div>
  );
};

export default PaymentAmount;
